// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/publish-switch/publish-switch.vue
// module id = 522
// module chunks = 2